import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=faf56da2&scoped=true&lang=html&"
import script from "./addEmail.vue?vue&type=script&lang=js&"
export * from "./addEmail.vue?vue&type=script&lang=js&"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=faf56da2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf56da2",
  null
  
)

component.options.__file = "addEmail.vue"
export default component.exports